import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { servicesData } from '../data/services';
import { FadeIn, SectionHeader } from '../components/UI';

function SkeletonCard() {
  return (
    <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div className="skeleton-line" style={{ width: '40%', height: 10 }} />
      <div className="skeleton-line" style={{ width: '70%', height: 16 }} />
      <div className="skeleton-line" style={{ width: '100%' }} />
      <div className="skeleton-line" style={{ width: '80%' }} />
      <div className="skeleton-line" style={{ width: '30%', height: 10, marginTop: 8 }} />
    </div>
  );
}

export default function YeteneklerPage() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(t);
  }, []);

  const handleServiceClick = (title) => {
    navigate('/iletisim', { state: { message: `${title} hizmeti hakkında bilgi almak istiyorum.` } });
  };

  return (
    <div className="page-enter" style={{ paddingTop: 72 }}>
      <section className="section">
        <div className="container">
          <SectionHeader
            label="Muhasebe Sistemi Ağı"
            title='Tüm Denetim Süreçleri <span>Tek Çatıda</span>'
            desc="E-dönüşüm paydaşları bir arada ve entegre muhasebe teknolojileri ağı"
            center
          />

          {loading ? (
            // Skeleton loading
            <div>
              {[1, 2].map((g) => (
                <div key={g} style={{ marginBottom: 56 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
                    <div className="skeleton-line" style={{ width: 160, height: 22, marginBottom: 0 }} />
                    <div style={{ flex: 1, height: 1, background: 'var(--slate-200)' }} />
                  </div>
                  <div className="services-grid">
                    {[1, 2, 3, 4].map((i) => <SkeletonCard key={i} />)}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            servicesData.map((group, gi) => (
              <FadeIn key={gi} delay={gi * 0.1}>
                <div className="service-group">
                  <div className="service-group-title">
                    <span style={{ color: 'var(--blue-500)', display: 'flex', alignItems: 'center', width: 22, height: 22 }}>
                      {group.icon}
                    </span>
                    {group.group}
                    <div className="service-group-line" />
                  </div>
                  <div className="services-grid">
                    {group.items.map((item, ii) => (
                      <div
                        key={ii}
                        className="service-item"
                        onClick={() => handleServiceClick(item.title)}
                      >
                        <div className="service-item-tag">{item.tag}</div>
                        <div className="service-item-title">{item.title}</div>
                        <div className="service-item-desc">{item.desc}</div>
                        <div className="service-item-arrow">
                          <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{ width: 16, height: 16 }}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                          </svg>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </FadeIn>
            ))
          )}
        </div>
      </section>
    </div>
  );
}
